import React from 'react'
import PropTypes from 'prop-types'
import PageHeader from './PageHeader'
import 'prismjs/themes/prism-tomorrow.css'

export default function BlogFull({ title, date, banner, html }) {
  return (
    <article className={'BlogFull'}>
      <PageHeader title={title} date={date} banner={banner} />
      <div
        className={'constrained'}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </article>
  )
}

BlogFull.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  banner: PropTypes.string,
  html: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/BlogFull.js